import { create, useModal } from '@ebay/nice-modal-react';

import EnterCurrentSecurityCodeStep from './EnterCurrentSecurityCodeStep';
import CreateSecurityCodeModal from '../CreateSecurityCodeModal/CreateSecurityCodeModal';

interface ChangeSecurityCodeModalProps {
  onSuccess?: () => void;
}

const ChangeSecurityCodeModal = create(({ onSuccess }: ChangeSecurityCodeModalProps) => {
  const modal = useModal();
  const { show: showCreateSecurityCodeModal } = useModal(CreateSecurityCodeModal);

  const handleConfirmed = () => {
    modal.remove();
    showCreateSecurityCodeModal({ mode: 'change', onSuccess });
  };

  return <EnterCurrentSecurityCodeStep close={modal.remove} onConfirmed={handleConfirmed} />;
});

export default ChangeSecurityCodeModal;
